<template lang="pug">
    div
        template(v-if="$store.state.queryGroupName == 'all'")
            Card
                div(style="text-align: center")
                    h3 Please choose a group to manage group pattern.
        template(v-else)
            div
                Card.a8-page-description-card
                    h2 {{$t('groupPattern.pageTitleText')}}
                    p Manage group style.
                Card
                    Row(type="flex" justify="space-between" align="middle")
                        Col(span="20")
                            div(style="display: flex; flex-direction: row; align-items: center;")
                                Icon(type="md-alert" size="24")
                                pre {{hintText}}
                        Col
                            Button(:type="$can('write', 'groupResourcesPermission','GroupPattern')?'primary':'default'" @click="updatePattern" :disabled="!$can('write', 'groupResourcesPermission','GroupPattern')") {{ $t("rcmtable.saveText") }}
                    Card(v-for="item in groupPatternItems" :key="item.key" dis-hover :bordered="false")
                        h4 {{item.name}}
                        component(ref="component"
                                    :is="item.component"
                                    v-model="groupPatternData[item.key]"
                                    :uploadImageItem="item.uploadImageItem"
                                    :groupAcmeData="groupAcmeData"
                                    :groupName="$store.state.queryGroupName"
                                    :disabled="!$can('write', 'groupResourcesPermission','GroupPattern')"
                                    :placeholder="item.placeholder"
                                    @updateLoginPage="updateLoginPage($event)"
                                    @updateLoginPageConfig="updateLoginPageConfig($event)"
                                    @updateBrandTitle="updateBrandTitle($event)"
                                    @reloadData="getData()")
</template>
<script>
import Vue from "vue";
import bus from "@/libs/bus.js";

import ImageUpload from "@/components/GroupPatternFormItems/ImageUpload";
import LoginPageSelector from "@/components/GroupPatternFormItems/LoginPageSelector";
import ThemeSelector from "@/components/GroupPatternFormItems/ThemeSelector";
import InputWithButton from "@/components/GroupPatternFormItems/InputWithButton";
import CertUpload from "@/components/GroupPatternFormItems/CertModal";

import { getGroupPattern, updateGroupPattern } from "@/api/groupasset.js";
import { updateGroupInfo } from "@/api/group";

export default {
    name: "GroupResource",
    components: {},
    data() {
        return {
            data: [],
            esIndex: "rcm-edgegroup-pattern",
            drawerTitleKey: "groupName",
            assetCategory: "groupResources",
            groupPatternData: {
                portalDomain: "",
                brandtitle: "",
                headerlogo: 0,
                favicon: 0,
                loginpage: {
                    currentuse: 0,
                    config: {
                        loginlogo: 0,
                        loginbackground: 0,
                        logindescription: "",
                        layout: 0,
                    },
                },
                theme: 0,
                portalAcme: "",
            },
            groupAcmeData: {
                certpemRaw: "",
                certchainRaw: "",
                certkeyRaw: "",
            },
            groupPatternItems: [
                {
                    key: "portalDomain",
                    name: this.$i18n.t("groupPattern.portalDomain"),
                    component: "Input",
                    value: "",
                    placeholder: this.$t("groupPattern.portalDomainPlaceholder"),
                },
                {
                    key: "portalAcme",
                    name: this.$i18n.t("groupPattern.certification"),
                    component: CertUpload,
                    value: "",
                },
                {
                    key: "brandtitle",
                    name: this.$i18n.t("groupPattern.cdnTitle"),
                    component: InputWithButton,
                    value: "",
                },
                {
                    key: "headerlogo",
                    name: this.$i18n.t("groupPattern.headerLogo"),
                    component: ImageUpload,
                    value: 0,
                    uploadImageItem: {
                        name: "平台Logo圖片",
                        key: "headerLogoUpload",
                        uploadEndPoint: `headerlogo`,
                        currentImageUrlKey: `headerlogoUrl`,
                        handleUpload: {
                            format: ["jpg", "jpeg", "png", "svg"],
                            // 上傳成功後更新的欄位
                            successUpdateFields: ["headerlogo"],
                        },
                        showUploadList: true,
                        loadingStatus: false,
                    },
                },
                {
                    key: "favicon",
                    name: this.$i18n.t("groupPattern.favicon"),
                    component: ImageUpload,
                    value: 0,
                    uploadImageItem: {
                        name: "平台Favicon圖片",
                        key: "faviconUpload",
                        uploadEndPoint: `favicon`,
                        currentImageUrlKey: "faviconUrl",
                        handleUpload: {
                            format: ["jpg", "jpeg", "png", "svg", "ico"],
                            // 上傳成功後更新的欄位
                            successUpdateFields: ["favicon"],
                        },
                        showUploadList: true,
                        loadingStatus: false,
                    },
                },
                { key: "theme", name: this.$i18n.t("groupPattern.theme"), component: ThemeSelector, value: 0 },
                {
                    key: "loginpage",
                    name: this.$i18n.t("groupPattern.loginPage"),
                    component: LoginPageSelector,
                    value: {},
                },
            ],
            webfrontHost: window.location.hostname,
        };
    },
    computed: {},
    methods: {
        getData() {
            getGroupPattern({
                groupName: [this.$store.state.queryGroupName],
            }).then((res) => {
                this.groupPatternData = res.data.data;
                if (res.data.acme.success == true) {
                    this.groupAcmeData = res.data.acme.data._source;
                }
                for (var key in this.groupPatternData) {
                    this.groupPatternItems.map((item) => {
                        if (item.key == key) {
                            item.value = this.groupPatternData[key];
                        }
                    });
                }
            });
        },
        updateLoginPageConfig(config) {
            this.groupPatternData.loginpage.config = config;
            this.updatePattern();
        },
        updateLoginPage(currentUse) {
            this.groupPatternData.loginpage.currentuse = currentUse;
        },
        updateBrandTitle(brandTitle) {
            updateGroupInfo({
                params: "title",
                data: { brandTitle: brandTitle },
                groupName: [this.$store.state.queryGroupName],
            })
                .then((result) => {
                    this.$Notice.success({
                        title: this.$i18n.t("global.success"),
                        desc: `${result.message}`,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        updatePattern() {
            window.location.reload();
            updateGroupPattern({
                groupName: [this.$store.state.queryGroupName],
                data: this.groupPatternData,
            })
                .then((res) => {
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `更新成功`,
                    });
                    this.getData();
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
        getWebfrontHost() {
            let webfrontHost = this.$store.state.platformPlan.multiTenancyConfigs.webfrontHost;
            if (webfrontHost) this.webfrontHost = webfrontHost;
        },
    },
    computed: {
        hintText() {
            return this.$i18n.t("groupPattern.hintText").replace("webfrontHost", this.webfrontHost);
        },
    },
    mounted() {},
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
        this.getData();
        this.getWebfrontHost();
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/GroupPattern/Page.vue